module.exports = __webpack_public_path__ + "static/media/auditorium.8299fe77.jpg";